define((require) => {
    "use strict";

    const _                       = require("underscore");
    const CompactImageLibraryView = require("ui/editor/imageLibrary/CompactImageLibraryView");
    const ImageCollection         = require("data/ImageCollection");
    const ImprovedView            = require("editor/zbone/ImprovedView");
    const template                = require("ui/experience/action/properties/ImageToggleEffectPropertiesView.tpl");

    /**
     * A view representing the currently selected "swap image".
     *
     * @see MOS-2687
     */
    const SelectedImageView = ImprovedView.extend("SelectedImageView", {

        template: _.template("<label class='block'>Selected Image</label><div class='thumb-cover'></div>"),

        ui: {
            thumbCover: ".thumb-cover"
        },

        initialize(options) {
            this._imageLibrary = options.imageLibrary;
        },

        onShow() {
            // View stays hidden until we receive a "image:selected" event.
            this.$el.hide();

            this.listenTo(this._imageLibrary, "image:selected", (imageModel) => {
                this._renderThumb(imageModel);
            });
        },

        _renderThumb(imageModel) {
            const url = imageModel.get("absoluteThumbUrl");

            this.ui.thumbCover.css("backgroundImage", "url(" + url + ")");

            this.$el.show();
        }

    });

    /**
     * A view representing the properties of the <tt>ImageToggleEffect</tt>.
     *
     * @cfg {ImageToggleEffectModel} model
     *
     * @class ImageToggleEffectPropertiesView
     */
    return ImprovedView.extend({

        className: "image-toggle-effect-properties-view",

        template: template,

        regions: {
            imageToggleLibraryRegion: ".image-toggle-library-region",
            selectedImageRegion: ".selected-image-region"
        },

        onShow() {
            const imageLibrarySorting = this.viewScope.viewModel.get("imageLibrarySorting");
            const collection = new ImageCollection();
            const {viewModel} = this.viewScope;
            const imageLibrary = new CompactImageLibraryView({
                collection: collection,
                selectedImage: this.model && this.model.get("imageId") ? this.model : null,
                project: viewModel.get("project"),
                // Enable 'autoSelection', i.e. ensures that the CompactImageLibraryView will select the first image model in the collection, if any, and if no 'selectedImageId' is found or defined.
                autoSelection: true,
                imageLibrarySorting,
                itemViewOptions: {
                    imageTaggingEnabled: viewModel.get("imageTaggingEnabled"),
                    inventoryEnabled: viewModel.get("inventoryEnabled")
                }
            });

            this.listenTo(imageLibrary, "image:selected", (imageModel) => {
                this._updateModelProperties(imageModel, this.model);
            });

            this.imageToggleLibraryRegion.show(imageLibrary);
            this.selectedImageRegion.show(new SelectedImageView({imageLibrary: imageLibrary}));
        },

        /**
         * @private
         *
         * Updates the model properties.
         *
         * @param {ImageModel} sourceImage The source model to get the properties from.
         * @param {ImageWidgetModel} destinationImage The destination model to set the properties to.
         */
        _updateModelProperties(sourceImage, destinationImage) {
            destinationImage.set({
                altText:             sourceImage.get("altText"),
                imageId:             sourceImage.get("id"),
                originalImageHeight: sourceImage.get("height"),
                originalImageWidth:  sourceImage.get("width"),
                supportsResize:      sourceImage.get("supportsResize"),
                sourceType:          sourceImage.get("sourceType"),
                src:                 sourceImage.get("url")
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/properties/ImageToggleEffectPropertiesView.js